
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/employers",
      function () {
        return require("private-next-pages/employers/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/employers"])
      });
    }
  